import { render, staticRenderFns } from "./TeachSponsorJoboffers.vue?vue&type=template&id=5ec87cba&"
import script from "./TeachSponsorJoboffers.vue?vue&type=script&lang=js&"
export * from "./TeachSponsorJoboffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports